import React, {useEffect, useState} from 'react'
import _ from "lodash";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import AjaxButton from "../../../form/ajax_button";
import classNames from "classnames";
import {updateTagOwnerConnections} from "../../exhibition_actions";


const AddContactBookmarkButton = ({contact}) => {
  const dispatch = useDispatch()

  // const tagOwnerMediaFileBookmarkUrl = useSelector(state => state.tagOwnerMediaFileBookmarkUrl)
  // const tagOwnerMediaFileBookmarks = useSelector(state => state.tagOwnerMediaFileBookmarks)

  const contactTagOwnerConnections = useSelector(state => state.contactTagOwnerConnections)
  const tagOwnerConnectionUrl = useSelector(state => state.tagOwnerConnectionUrl)

  const hasBookmarked = _.some(contactTagOwnerConnections, (connection) => {
    return connection.id === contact.id
  })

  console.debug("contactTagOwnerConnections", {contactTagOwnerConnections, hasBookmarked})

  if (!tagOwnerConnectionUrl) {
    return <div className="btn btn-sm btn-dark disabled">
      <i className="fa fa-save fa-fw"></i> Bookmark
    </div>
  }

  return <AjaxButton
    method={hasBookmarked ? "delete" : "post"}
    label={hasBookmarked ? "Remove" : "Bookmark"}
    labelSending={hasBookmarked ? "Removing..." : "Bookmarking..."}
    className={classNames("btn btn-sm btn-dark")}
    icon={hasBookmarked ? "fa-trash" : "fa-save"}
    url={hasBookmarked ? `${tagOwnerConnectionUrl}/${contact.id}` : tagOwnerConnectionUrl}
    data={{
      contact_id: contact.id
    }}
    onSuccess={(data) => {
      if (data.data.status === "OK") {
        dispatch(updateTagOwnerConnections(data.data.contactTagOwnerConnections.map((connection) => connection.sender_tag_owner)))
      } else {
        alert(data.data.message || "A error occured while adding bookmark.")
      }
    }}
    onError={(error) => {
      console.log(error)
      alert("Error while adding bookmark", error)
    }}
  />
}

export default function ContactsPreview({data, onModalClose, imageMap}) {
  const contactsUrl = useSelector(state => state.contactsUrl)


  const actualContactsUrl = contactsUrl?.replace("@@image_map_id@@", imageMap.id)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [contacts, setContacts] = useState([])

  const loadContacts = () => {
    setIsLoading(true)
    setError(null)
    setContacts([])

    console.log({actualContactsUrl})

    axios.get(actualContactsUrl, {image_map_id: imageMap.id}).then(response => {
        if (response.data.status === "OK") {
          console.table(response.data.contacts)
          setError(null)
          setContacts(response.data.contacts)
        } else {
          setError(response.data.message)
          setContacts([])
        }
        setIsLoading(false)
      },
      error => {
        alert(error)
        console.error(error)

        setError(response.data.message)
        setContacts([])
      }).then(function () {
      setIsLoading(false)
    })
  }

  useEffect(() => {
    loadContacts()
  }, [])

  const sortedContacts = _.sortBy(contacts, ["contact_position", "name", "email", "id"], ["asc", "asc", "asc", "asc",])

  let content = <div>Currently no contacts available.</div>;

  if (isLoading) {
    content = <div className={"text-center"}>
      <div className="spinner-border text-dark" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  } else if (error) {
    content = <div className={"text-center"}>
      An error occured while loading.

      <hr/>
      {error}
      <hr/>

      <button className="btn btn-danger"
              onClick={() => loadContacts(contactsUrl, setIsLoading, setError, setContacts)}
      >Reload
      </button>
    </div>
  } else if (sortedContacts && sortedContacts.length > 0) {
    content = <>
      {sortedContacts.map((contact, index) => {
        return <div key={contact.id}>
          {index > 0 ? <hr/> : null}

          <div className="row">
            <div className="col-3">
              <img className={"img-fluid"} src={contact.imageUrl}/>
            </div>
            <div className="col-9">
              <strong>{contact.name}</strong>
              <br/>
              <a href={"mailto:" + contact.email}>{contact.email}</a>
              <br/>
              {contact.job_title}
              <br/>
              <a href={contact.vcfUrl}>Download vcf here</a>
              <br/>
              <AddContactBookmarkButton contact={contact}/>
            </div>
          </div>
        </div>
      })}
    </>
  }

  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" onClick={(event) => {
        event.stopPropagation()
      }}>
        <div className="modal-header">
          <div className="modal-title">
            {data.title}
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {content}
        </div>
      </div>
    </div>
  </div>;
}
